import { setConfig } from 'litto-lib/utils';

export const configCloudinary = () => {
	setConfig({
		cloudName: `${process.env.CLOUDINARY_CLOUD_NAME}`,
		cloudNamePrefix: `${process.env.CLOUDINARY_CLOUD_NAME_PREFIX}`
	});
};
